import { useState } from 'react';
import styled, { Box, css, useTheme } from '@xstyled/styled-components';
import Button from '@/UI/Button';
import { CategoryTitle } from '@/UI/Primitives/Headings';
import { Chevron } from '@/UI/Icons';

const FilterTypeBox = styled.div`
  margin-bottom: 1.5rem;

  button:hover {
    h3 {
      color: teal-200;
    }

    svg path {
      fill: #45aac4;
    }
  }
`;

const FilterValues = styled.div`
  ${({ title }) =>
    title !== 'KATEGOORIA' &&
    css`
      max-height: 290px;
      overflow-y: auto;
      overflow-x: hidden;
      scrollbar-color: #96e7e7 #fafafa;
      scrollbar-width: 10%;
      
      &::-webkit-scrollbar {
        width: 10px;
      }

      &::-webkit-scrollbar-track {
        background-color: #fafafa;
      }

      &::-webkit-scrollbar-thumb {
        background-color: #96e7e7;
      }
    `}
`;

export default function FilterType({ title, children }) {
  const theme = useTheme();

  const [open, setOpen] = useState(true);
  const [rotate, setRotate] = useState('rotate(90deg)');

  const toggle = () => {
    setOpen(open => !open);
    setRotate(open ? rotate === 'rotate(90deg)' : 'rotate(-270deg)');
  };

  return (
    <FilterTypeBox as="form">
      <Button
        w="100%"
        display="inline-flex"
        alignItems="center"
        justifyContent="space-between"
        pb="1rem"
        pl={{ _: '1.75rem', desktop: '0' }}
        onClick={toggle}
      >
        <CategoryTitle fontSize="xsmall">{title}</CategoryTitle>
        <Box
          as="span"
          display={{ _: 'none', desktop: 'inline' }}
          transform={`${rotate}`}
        >
          <Chevron fill={theme.colors['teal-300']} />
        </Box>
      </Button>
      <FilterValues title={title}>{open && children}</FilterValues>
    </FilterTypeBox>
  );
}
